import React from 'react'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ButtonGroup, Button, Typography } from '@mui/material'

interface StepQuantityProps {
  disabledPlus: boolean
  disabledLess: boolean
  onClickPlus: () => void
  onClickLess: () => void
  quantity: number
}

export const StepQuantity: React.FC<StepQuantityProps> = ({
  disabledLess,
  disabledPlus,
  onClickLess,
  onClickPlus,
  quantity
}) => {
  return (
    <ButtonGroup variant='contained' color='primary'>
      <Button
        onClick={onClickLess}
        disabled={disabledLess}
        color='primary'
        variant='contained'
        size='small'
      >
        <ExpandMoreIcon />
      </Button>
      <Typography align='center' variant='h6' style={{ color: 'black' }}>
        {quantity}
      </Typography>
      <Button
        onClick={onClickPlus}
        color='primary'
        variant='contained'
        size='small'
        disabled={disabledPlus}
      >
        <ExpandLessIcon />
      </Button>
    </ButtonGroup>
  )
}
